"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanPhoneNumber = void 0;

/**
 * Strips non-numeric characters and removes leading '1' digit of the length is equal to 11.
 * Return null if !number
 * @param {string} number
 * @return {null|string}
 */
var cleanPhoneNumber = function cleanPhoneNumber(number) {
  if (!number) {
    return null;
  } // let updatedNumber = number.replace(/[^0-9+]/g, '');
  // if (!number) {
  //   return null;
  // }
  // eslint-disable-next-line radix
  // if (number.length === 11 && Number.parseInt(updatedNumber[0]) === 1) {
  //   updatedNumber = number.slice(1);
  // }


  return number;
};

exports.cleanPhoneNumber = cleanPhoneNumber;